module.exports = __webpack_public_path__ + "static/media/next (12).03f70702.svg";